import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/fire-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1fe47557"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-2"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "card-footer" }
const _hoisted_4 = { class: "left-items" }
const _hoisted_5 = { class: "task-info" }
const _hoisted_6 = { class: "task-type" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#taskSidebar",
  ref: "openModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_user_selection = _resolveComponent("user-selection")!
  const _component_SelectDate = _resolveComponent("SelectDate")!
  const _component_task_status_select = _resolveComponent("task-status-select")!

  return (_ctx.task)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "card-body",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openTaskSidebar(_ctx.task)), ["prevent"]))
        }, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.task.headline), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.task.description
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_user_selection, {
              selectedUsers: _ctx.computedAccountablePerson,
              "onUpdate:selectedUsers": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedAccountablePerson) = $event)),
              checkAgainstModule: true,
              label: "Select Accountable User",
              exactlyOne: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LogoAndName, {
                  user: _ctx.computedAccountablePerson[0],
                  middleAvatarSize: true,
                  rowView: true
                }, null, 8, ["user"])
              ]),
              _: 1
            }, 8, ["selectedUsers"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.task.taskType), 1),
              (!_ctx.dueDateEdit)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "due-date",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dueDateEdit = true))
                  }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.formattedDueDate), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_SelectDate, {
                      date: _ctx.computedDueDate,
                      "onUpdate:date": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedDueDate) = $event))
                    }, null, 8, ["date"])
                  ]))
            ])
          ]),
          _createVNode(_component_task_status_select, {
            status: _ctx.task.status,
            modelValue: _ctx.computedStatus,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedStatus) = $event))
          }, null, 8, ["status", "modelValue"])
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_9, "Open", 512), [
          [_vShow, false]
        ])
      ]))
    : _createCommentVNode("", true)
}